import { JobModalState, JobItem } from "@/type/commonTypes";
import { createSlice, PayloadAction } from "@reduxjs/toolkit";

const initialState: JobModalState = {
  isOpen: false,
  selectedJob: null,
};

export const jobModalSlice = createSlice({
  name: "jobModal",
  initialState,
  reducers: {
    openJobModal: (state, action: PayloadAction<JobItem>) => {
      state.isOpen = true;
      state.selectedJob = action.payload;
    },
    closeJobModal: (state) => {
      state.isOpen = false;
    },
  },
});

export const { openJobModal, closeJobModal } = jobModalSlice.actions;
export default jobModalSlice.reducer;
